import PortalIdParser from 'PortalIdParser';
import styled from 'styled-components';
import { KOALA, OLAF } from 'HubStyleTokens/colors';
import getIn from 'transmute/getIn';
import { getIsCallIncoming, getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { logNetworkError } from 'calling-lifecycle-internal/utils/logNetworkError';
import InboundCallingTracker from 'calling-lifecycle-usage-tracker/inboundCallingTracker';
import { getPropertyName, getObjectId, getObjectTypeId, getPhoneNumberProperties, getMetadata } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
// @ts-expect-error module not typed
import CurrentSettingsInfoWorkspace from './CurrentSettingsInfoWorkspace';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { isCallingFree } from 'calling-internal-common/utils/CallingSalesPro';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getStandaloneConnectionId } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createInitiateOutboundCallMessage } from 'calling-lifecycle-messages/deviceEventCreators';
import { getAccountTypeFromPhoneNumber } from 'calling-ui-library/utils/getAccountTypeFromPhoneNumber';
import { getDefaultAssociationsWithCallee } from '../../associations/getDefaultAssociationsWithCallee';
import { getAssociations } from '../../associations/getAssociations';
import { getCallTabUrl } from '../../utils/getCallTabUrl';
import { INITIATE_OUTBOUND_CALL_MESSAGE } from 'calling-lifecycle-messages/deviceEventConstants';
import { logCallingError } from 'calling-error-reporting/report/error';
import { getIsMinutesUsageOverLimit } from 'calling-lifecycle-internal/calls-v1-settings-usage/operators/MinuteUsageSummaryGetters';
import { useState } from 'react';
import { ChangeProviderLink } from './ChangeProviderLink';
import { CallSource } from 'calling-cross-tab-library/constants/CallSource';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { INBOX } from 'calling-internal-common/constants/appIdentifiers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNotesButtonWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersWorkspace__CallNotesButtonWrapper",
  componentId: "sc-19jdnh1-0"
})(["position:sticky;bottom:0;background:", ";border-style:solid;border-width:2px 0 0 0;border-color:", ";"], OLAF, KOALA);
const CalleeSelectDropdownWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersWorkspace__CalleeSelectDropdownWrapper",
  componentId: "sc-19jdnh1-1"
})(["max-height:400px;overflow:auto;"]);
const CallSettingsNumbersWorkspace = props => {
  const {
    appIdentifier,
    defaultFromNumber,
    channelAssignedPhoneNumbers,
    isKnownVisitor,
    visitorPhoneNumber,
    gates
  } = props;
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeConnectionId = getStandaloneConnectionId(widgetDetails);
  const activeCallTabOpen = Boolean(activeConnectionId);
  const crossTabCallStatus = getCallStatus(widgetDetails);
  const isMinutesUsageOverLimit = getIsMinutesUsageOverLimit(props.minutesUsage);
  const defaultFromNumberRecord = channelAssignedPhoneNumbers.size === 1 ? channelAssignedPhoneNumbers.get(0) :
  // use latest number that was used to call or be called
  channelAssignedPhoneNumbers.find(number => number.get('phoneNumber') === defaultFromNumber);
  const [selectedFromNumber, setSelectedFromNumber] = useState(defaultFromNumberRecord);
  const isInbox = appIdentifier === INBOX;
  const source = isInbox ? CallSource.INBOX : CallSource.HELP_DESK;
  const openCallTabAndStartOutboundCall = ({
    callableObject,
    toNumber,
    fromNumber,
    accountType,
    associations,
    requireContactOrCompany
  }) => {
    const portalId = PortalIdParser.get();
    const trimmedCallableObject = {
      objectId: getObjectId(callableObject),
      objectTypeId: getObjectTypeId(callableObject),
      crmObjectSubscriptionStatus: getIn(['crmObjectSubscriptionStatus'], callableObject)
    };
    const queryString = `action=${INITIATE_OUTBOUND_CALL_MESSAGE}&callableObject=${JSON.stringify(trimmedCallableObject)}&fromNumber=${fromNumber}&toNumber=${toNumber}&source=${source}&accountType=${accountType}&associations=${JSON.stringify(associations)}&requireContactOrCompany=${requireContactOrCompany}`;
    window.open(getCallTabUrl(portalId, queryString), 'calling-window', 'menubar=no,resizable=yes,scrollbars=no,location=no,width=740,height=750');
  };
  const startOutboundCall = async ({
    numberIdentifier,
    callableObject
  }) => {
    const numberPropertyName = getPropertyName(numberIdentifier);
    const phoneNumberProperties = getPhoneNumberProperties(callableObject);
    const propertyToCall = getIn([numberPropertyName], phoneNumberProperties) || null;
    const phoneNumberMetadata = propertyToCall && getMetadata(propertyToCall);
    const toNumber = phoneNumberMetadata.toNumberString;
    const objectId = getObjectId(callableObject);
    const objectTypeId = getObjectTypeId(callableObject);
    const fromNumber = getIn(['phoneNumber'], selectedFromNumber);
    const accountType = getAccountTypeFromPhoneNumber(selectedFromNumber);
    const callableObjectJS = callableObject.toJS();
    const _callableObject = {
      crmObjectSubscriptionStatus: callableObjectJS.crmObjectSubscriptionStatus,
      objectId: callableObjectJS.objectId,
      objectTypeId: callableObjectJS.objectTypeId
    };
    let associations = null;
    if (fromNumber) if (isKnownVisitor) {
      associations = await getAssociations({
        objectTypeId,
        objectId
      }).then(associationsRes => {
        return getDefaultAssociationsWithCallee({
          callableObject: {
            objectTypeId,
            objectId
          },
          uasAssociations: associationsRes
        });
      }).catch(networkError => {
        logNetworkError({
          networkError,
          error: new Error('Error fetching associations for outgoing call'),
          tags: {
            requestName: 'query fetchUniversalEngagementAssociations'
          }
        });
        return null;
      });
    }
    associations = associations ? associations.toJS() : {
      [objectTypeId]: [objectId]
    };
    InboundCallingTracker.trackCallTabStartOutboundCall({
      appIdentifier: props.appIdentifier
    });
    if (activeCallTabOpen) {
      sendCrossTabMessage(createInitiateOutboundCallMessage({
        destinationConnectionId: activeConnectionId,
        callableObject: _callableObject,
        toNumber,
        fromNumber: fromNumber,
        source,
        accountType,
        associations: isKnownVisitor ? associations : {},
        requireContactOrCompany: isKnownVisitor
      })).catch(error => {
        logCallingError({
          error,
          tags: {
            requestName: 'sendCrossTabMessage - initiate outbound call'
          }
        });
      });
    } else {
      openCallTabAndStartOutboundCall({
        callableObject: _callableObject,
        toNumber,
        fromNumber: fromNumber,
        accountType,
        associations: isKnownVisitor ? associations : {},
        requireContactOrCompany: isKnownVisitor
      });
    }
    props.onCallButtonClick();
  };
  const {
    asyncCalleeOmnibus,
    widgetState,
    selectedCallProvider,
    scopes,
    showChangeProviderLink,
    onCallButtonClick
  } = props;
  const calleeOmnibusData = getData(asyncCalleeOmnibus);
  const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
  const shouldShowActiveWidgetCallState = getShouldShowActiveCallState(widgetState.get('callStatus'));
  const isFreeCalling = isCallingFree(scopes);
  const isCrossTabCallStatusActive = getShouldShowActiveCallState(crossTabCallStatus) || getIsCallIncoming(crossTabCallStatus);
  const disabledTooltipMessage = !selectedFromNumber ? 'callSettingsOptions.noSelectedFromNumber' : isFreeCalling ? 'callSettingsOptions.freeSeatHubSpotCallingBlocked' : isMinutesUsageOverLimit ? `callSettingsOptions.minutesUsageOverLimit` : isCrossTabCallStatusActive || shouldShowActiveWidgetCallState ? 'callSettingsOptions.callActiveOutboundCallBlocked' : null;
  return /*#__PURE__*/_jsxs(CalleeSelectDropdownWrapper, {
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: appIdentifier,
      calleesData: calleesData,
      onSelectToNumber: startOutboundCall,
      disabled: !!disabledTooltipMessage,
      canEdit: false,
      showAddPropertyButton: false,
      disabledTooltipMessage: disabledTooltipMessage,
      isKnownVisitor: isKnownVisitor,
      visitorPhoneNumber: visitorPhoneNumber,
      gates: gates
    }), /*#__PURE__*/_jsxs(CallNotesButtonWrapper, {
      children: [showChangeProviderLink && /*#__PURE__*/_jsx(ChangeProviderLink, {
        onCallButtonClick: onCallButtonClick,
        providerName: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callWidgetProviders.HubSpot.widgetTitle"
        })
      }), /*#__PURE__*/_jsx(CurrentSettingsInfoWorkspace, {
        selectedCallProvider: selectedCallProvider,
        selectedFromNumber: selectedFromNumber,
        handleSelectFromNumber: setSelectedFromNumber,
        channelAssignedPhoneNumbers: channelAssignedPhoneNumbers,
        defaultPhoneNumber: defaultFromNumber,
        appIdentifier: appIdentifier
      })]
    })]
  });
};
export default CallSettingsNumbersWorkspace;